export default "__VITE_ASSET__C3qcIb3z__"